// src/features/counterSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GlobalState {
  setupTab: number;
  reportsTab: number;
  inventoryTab: number;
  checklistTab: number;
  trackerTab: number;
  setupTabItems: string[];
  reportsTabItems: string[];
  inventoryTabItems: string[];
  checklistTabItems: string[];
  trackerTabItems: string[];
}

const initialState: GlobalState = {
  setupTab: 0,
  reportsTab: 0,
  inventoryTab: 0,
  checklistTab: 0,
  trackerTab: 0,
  setupTabItems: [
    'Add Company',
    'Sites',
    'Users',
    'Report Builder',
    'Licenses & Certifications',
  ],
  reportsTabItems: [''],
  inventoryTabItems: [''],
  checklistTabItems: [''],
  trackerTabItems: [''],
};

export const tabSlice = createSlice({
  name: 'tab',
  initialState,
  reducers: {
    setSetupTab: (state, action) => {
      state.setupTab = action.payload;
    },
    setReportsTab: (state, action) => {
      state.reportsTab = action.payload;
    },
    setInventoryTab: (state, action) => {
      state.inventoryTab = action.payload;
    },
    setTrackerTab: (state, action) => {
      state.trackerTab = action.payload;
    },
    setChecklistTab: (state, action) => {
      state.checklistTab = action.payload;
    },
    setReportsTabItems: (state, action: PayloadAction<string[]>) => {
      const items = action.payload.map((item: any) => item.reportName);
      state.reportsTabItems = [...items];
    },
    setInventoryTabItems: (state, action: PayloadAction<string[]>) => {
      const items = action.payload.map((item: any) => item.reportName);
      state.inventoryTabItems = [...items];
    },
    setChecklistTabItems: (state, action: PayloadAction<string[]>) => {
      const items = action.payload.map((item: any) => item.reportName);
      state.checklistTabItems = [...items];
    },
    setTrackerTabItems: (state, action: PayloadAction<string[]>) => {
      const items = action.payload.map((item: any) => item.reportName);
      state.trackerTabItems = [...items];
    },
  },
});

export const {
  setTrackerTab,
  setChecklistTab,
  setChecklistTabItems,
  setTrackerTabItems,
  setInventoryTabItems,
  setSetupTab,
  setReportsTab,
  setReportsTabItems,
  setInventoryTab,
} = tabSlice.actions;

export default tabSlice.reducer;
